import { MIDNIGHT, toSeconds } from "../utils/date";

export const findLeadParcel = (parcels) => {
  let bestTime = MIDNIGHT;
  let leadParcel = {};

  parcels.forEach((parcel) => {
    if (toSeconds(parcel.serviceEndTime) < toSeconds(bestTime)) {
      bestTime = parcel.serviceEndTime;
      leadParcel = parcel;
    } else if (toSeconds(parcel.serviceEndTime) === toSeconds(bestTime)) {
      if (parcel.priority < leadParcel.priority) {
        bestTime = parcel.serviceEndTime;
        leadParcel = parcel;
      }
    }
  });

  return leadParcel;
};

export const nonCadScannedParcel = (parcel) => !parcel.cadScanned;

export const isContinuousWaveParcel = ({ parcelStatus }) =>
  parcelStatus === "B";

export const convertParcelStatus = (parcel) => (parcel.loaded && "L") || null;

export const getBulkTestIdString = (isBulk, isBulkDisabled) => {
  const nameString = "bulk-checkbox";

  if (isBulkDisabled) {
    return `${nameString}-disabled`;
  }

  return isBulk ? `${nameString}-checked` : `${nameString}-unchecked`;
};

export const hasHighValueParcel = (data = []) =>
  data.some((item) => item.highValue || item.smallsToteParcel);
